import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getSubscription,
  createCheckoutSession,
  createBillingPortalSession,
} from "@/lib/api-client";

export function useSubscription(venueId: string | null) {
  return useQuery({
    queryKey: ["subscription", venueId],
    queryFn: async () => {
      const response = await getSubscription(venueId!);
      return response.data;
    },
    enabled: !!venueId,
    staleTime: 30_000,
    retry: 1,
  });
}

export function useCreateCheckoutSession() {
  return useMutation({
    mutationFn: async ({ venueId }: { venueId: string }) => {
      const response = await createCheckoutSession({ venueId });
      return response.data;
    },
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}

export function useCreateBillingPortalSession() {
  return useMutation({
    mutationFn: async ({ venueId }: { venueId: string }) => {
      const response = await createBillingPortalSession({ venueId });
      return response.data;
    },
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}
